import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export interface GlobalSearchResult {
  type: string;
  id: number;
  title: string;
  subtitle?: string;
  path: string;
  module: string;
}

export const searchApi = {
  global: (q: string) =>
    unwrap(api.get<ApiResponse<GlobalSearchResult[]>>('/v1/platform/search', { params: { q } })),
};
